import React from 'react';
import InfoBox from './InfoBox';
import { translate } from '../Services/translation';
import Icon from './Icon';
import clsx from 'clsx';
import { InfoBoxPlacements } from '../constants';

const StockStatus = ({
  inStock,
  description,
  showInfoBox,
  stockMessage,
  placement = InfoBoxPlacements.Top,
}) => {
  return (
    <div className="stock-status">
      <Icon
        name={inStock ? 'Check-Rounded-Filled' : 'Caution-Rounded-Filled'}
        className={clsx(
          'stock-status__icon',
          inStock ? 'in-stock' : 'on-request'
        )}
        size={24}
      />
      {description && (
        <div className="stock-status__description">{description}</div>
      )}
      {showInfoBox ? (
        <InfoBox
          label={stockMessage}
          id="stock-status-box"
          placement={placement}
        >
          {translate(
            inStock
              ? 'product.stockstatus.info.in-stock'
              : 'product.stockstatus.info.on-request'
          )}
        </InfoBox>
      ) : (
        <div className="stock-status__message">{stockMessage}</div>
      )}
    </div>
  );
};

export default StockStatus;
